// extracted by mini-css-extract-plugin
export var bodySections = "_44-8";
export var gray = "_44-7";
export var green = "_44-4";
export var iconContainer = "_44-9";
export var iconWidgetContainer = "_44-1";
export var phoneIcon = "_44-2";
export var red = "_44-5";
export var statusDot = "_44-3";
export var widgetContainer = "_44-0";
export var yellow = "_44-6";